module.exports = __webpack_public_path__ + "img/img5.dd269ed5.png";